import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';

import { ManagementEntityEventModel } from '@data-layer/models/management';
import { EntryErrorModel } from '@data-layer/models/entry-summaries';
import { CbpMessageModel } from '@data-layer/models/common';

@Injectable({
  providedIn: 'root',
})
export class EntrySummaryMessagesRepository {
  constructor(private apiService: ApiService) {}

  public getCbpMessages(id: number, isShowLoader: boolean = true, isUsed: boolean = false): Observable<CbpMessageModel[]> {
    return this.apiService.get<CbpMessageModel[]>(`${environment.url.prefixCustoms}v2/entry-summaries/${id}/cbp-messages`, null, {
      isShowLoader,
      isUsed,
    });
  }

  public getCbpRawMessages(id: number, isShowLoader: boolean = true, isUsed: boolean = false): Observable<ManagementEntityEventModel[]> {
    return this.apiService.get<ManagementEntityEventModel[]>(
      `${environment.url.prefixCustoms}v2/entry-summaries/${id}/raw-messages`,
      null,
      {
        isShowLoader,
        isUsed,
      },
    );
  }

  public getLdsExceptions(id: number, isShowLoader: boolean = true, isUsed: boolean = false): Observable<EntryErrorModel[]> {
    return this.apiService.get<EntryErrorModel[]>(`${environment.url.prefixCustoms}v2/entry-summaries/${id}/errors`, null, {
      isShowLoader,
      isUsed,
    });
  }

  public getManagementCbpMessages(id: number, isShowLoader: boolean = true): Observable<ManagementEntityEventModel[]> {
    return this.apiService.get<ManagementEntityEventModel[]>(`${environment.url.esManagement}${id}/messages`, null, { isShowLoader });
  }

  public getManagementLdsExceptions(id: number, isShowLoader: boolean = true): Observable<EntryErrorModel[]> {
    return this.apiService.get<EntryErrorModel[]>(`${environment.url.esManagement}${id}/errors`, null, { isShowLoader });
  }
}
